// This file stores web3 related constants such as addresses, token definitions, ETH currency references and ABI's

export const NFT_SYMBOL = "SPASS";
export const NFT_NAME = "SmartyPants NFT";
export const NFT_DESCRIPTION = "Referral/reward NFT";
export const NFT_METADATA_URI = process.env.REACT_APP_NFT_METADATA_URI || "";
export const TOKEN_MINT = process.env.REACT_APP_TOKEN_MINT || "";
export const MAX_LEVEL_LENGTH = 4;
export const USDC_MINT = process.env.REACT_APP_USDC_MINT || "";
export const USDT_MINT = process.env.REACT_APP_USDT_MINT || "";
export const RPC_URL = process.env.REACT_APP_RPC_URL || "";
export const IP_INFO_API_KEY = process.env.REACT_APP_IP_INFO_API_KEY || "";
